import { render, staticRenderFns } from "./AddCourseArticle.vue?vue&type=template&id=50d3e3c4&scoped=true"
import script from "./AddCourseArticle.vue?vue&type=script&lang=js"
export * from "./AddCourseArticle.vue?vue&type=script&lang=js"
import style0 from "./AddCourseArticle.vue?vue&type=style&index=0&id=50d3e3c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d3e3c4",
  null
  
)

export default component.exports